import { EightTrackIcon } from './EightTrackIcon';

/**
 * author: GreenTurtwig
 * id 589595AF-C8FF-451B-A623-2A22D0D2A181
 * name eight-track
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eight-track.svg
 * tags
 * - Music 
 */
export const _8TrackIcon = EightTrackIcon;
export default _8TrackIcon